export default __webpack_public_path__ + "static/media/无人之岛.b5d633d0.mp3";